import React from 'react';
import { ContentList, ContentListItem } from '../../../../_lib/components/ContentList';
import UserSearchResultTable from './partials/UserSearchResultTable';
import { ContactPerson } from '../../../../_lib/components/ContactPerson';
import { murmurhash } from '../../../../lib/js/hash';
import { useLoadMore } from '../../../../_lib/components/LoadMore/useLoadMore';
import { LoadMore } from '../../../../_lib/components/LoadMore/LoadMore';
import { LoadMoreButtonType } from '../../../../_lib/components/LoadMore/partials/LoadMoreButton';
import { ResultUser } from '../../../../types/Search.types';

type UserSearchResultsType = {
  blockLayout?: string;
  resultUsers: ResultUser[];
  loadMore?: LoadMoreButtonType;
};

export default function UserSearchResults({ blockLayout, resultUsers, loadMore }: UserSearchResultsType) {
  const { resultList, loadingStatus, loadMoreStatus, itemToBeFocused, listContainerRef, listItemRef, loadMoreItems } =
    useLoadMore<ResultUser>(loadMore, resultUsers);

  if (!resultList || resultList.length === 0) {
    return null;
  }

  // blockLayout comes sometimes as undefined
  const isTable = () => {
    return !blockLayout || blockLayout === 'large';
  };

  return isTable() ? (
    <UserSearchResultTable items={resultUsers} />
  ) : (
    <LoadMore
      loadMore={loadMore}
      loadMoreStatus={loadMoreStatus}
      loadMoreItems={loadMoreItems}
      loadingStatus={loadingStatus}
      ref={listContainerRef}
    >
      <ContentList>
        {resultList.map((user, index) => (
          <ContentListItem
            key={murmurhash(user)}
            ref={
              itemToBeFocused && loadingStatus === 'success' && index === itemToBeFocused - 1 ? listItemRef : undefined
            }
          >
            <ContactPerson {...(user as any)} />
          </ContentListItem>
        ))}
      </ContentList>
    </LoadMore>
  );
}
